import { render, staticRenderFns } from "./VersionChecker.vue?vue&type=template&id=0ac27e0a&"
import script from "./VersionChecker.vue?vue&type=script&lang=js&"
export * from "./VersionChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports